import React from 'react';
import { useTranslation } from 'react-i18next';

import { DeleteDialog } from '@components/dialogs/DeleteDialog';
import { enqueueSnackbar } from 'notistack';
import { IDeleteFeedMessageDialog } from './interface';
import { useDeleteFeedMessage } from '@reactQuery/feeds/feed';

export const DeleteFeedMessageDialog: React.FC<IDeleteFeedMessageDialog> = ({
  show = true,
  messageId,
  onClose,
  onMessageDeleted,
}): JSX.Element => {
  const { t } = useTranslation();

  const { mutate: deleteFeedMessage, isPending: isDeletingFeedMessage } =
    useDeleteFeedMessage();

  const handleDelete = () => {
    if (isDeletingFeedMessage) {
      return;
    }

    deleteFeedMessage(messageId, {
      onSuccess: () => {
        if (onClose) {
          onClose();
        }

        if (onMessageDeleted) {
          onMessageDeleted();
        }
      },
      onError: () => {
        enqueueSnackbar(t('feed:dialogs.deleteMessage.failed'), {
          variant: 'error',
        });
      },
    });
  };

  return (
    <DeleteDialog
      show={show}
      title={t('feed:dialogs.deleteMessage.title')}
      onClose={onClose}
      onConfirm={handleDelete}
      disabled={isDeletingFeedMessage}
    >
      {t('feed:dialogs.deleteMessage.body')}
    </DeleteDialog>
  );
};
